
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "pl",
  "cs",
  "et",
  "es",
  "fr",
  "hr",
  "it",
  "lv",
  "lt",
  "hu",
  "nl",
  "pt",
  "ro",
  "sk",
  "sl",
  "sr",
  "tr",
  "el",
  "bg",
  "ru"
]

export const localeLoaders = {
  "en": [{ key: "../i18n/locales/en.json", load: () => import("../i18n/locales/en.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_en_json" */), cache: true }],
  "de": [{ key: "../i18n/locales/de.json", load: () => import("../i18n/locales/de.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_de_json" */), cache: true }],
  "pl": [{ key: "../i18n/locales/pl.json", load: () => import("../i18n/locales/pl.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_pl_json" */), cache: true }],
  "cs": [{ key: "../i18n/locales/cs.json", load: () => import("../i18n/locales/cs.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_cs_json" */), cache: true }],
  "et": [{ key: "../i18n/locales/et.json", load: () => import("../i18n/locales/et.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_et_json" */), cache: true }],
  "es": [{ key: "../i18n/locales/es.json", load: () => import("../i18n/locales/es.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_es_json" */), cache: true }],
  "fr": [{ key: "../i18n/locales/fr.json", load: () => import("../i18n/locales/fr.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_fr_json" */), cache: true }],
  "hr": [{ key: "../i18n/locales/hr.json", load: () => import("../i18n/locales/hr.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_hr_json" */), cache: true }],
  "it": [{ key: "../i18n/locales/it.json", load: () => import("../i18n/locales/it.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_it_json" */), cache: true }],
  "lv": [{ key: "../i18n/locales/lv.json", load: () => import("../i18n/locales/lv.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_lv_json" */), cache: true }],
  "lt": [{ key: "../i18n/locales/lt.json", load: () => import("../i18n/locales/lt.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_lt_json" */), cache: true }],
  "hu": [{ key: "../i18n/locales/hu.json", load: () => import("../i18n/locales/hu.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_hu_json" */), cache: true }],
  "nl": [{ key: "../i18n/locales/nl.json", load: () => import("../i18n/locales/nl.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_nl_json" */), cache: true }],
  "pt": [{ key: "../i18n/locales/pt.json", load: () => import("../i18n/locales/pt.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_pt_json" */), cache: true }],
  "ro": [{ key: "../i18n/locales/ro.json", load: () => import("../i18n/locales/ro.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_ro_json" */), cache: true }],
  "sk": [{ key: "../i18n/locales/sk.json", load: () => import("../i18n/locales/sk.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_sk_json" */), cache: true }],
  "sl": [{ key: "../i18n/locales/sl.json", load: () => import("../i18n/locales/sl.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_sl_json" */), cache: true }],
  "sr": [{ key: "../i18n/locales/sr.json", load: () => import("../i18n/locales/sr.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_sr_json" */), cache: true }],
  "tr": [{ key: "../i18n/locales/tr.json", load: () => import("../i18n/locales/tr.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_tr_json" */), cache: true }],
  "el": [{ key: "../i18n/locales/el.json", load: () => import("../i18n/locales/el.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_el_json" */), cache: true }],
  "bg": [{ key: "../i18n/locales/bg.json", load: () => import("../i18n/locales/bg.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_bg_json" */), cache: true }],
  "ru": [{ key: "../i18n/locales/ru.json", load: () => import("../i18n/locales/ru.json" /* webpackChunkName: "locale__app_apps_mini_i18n_locales_ru_json" */), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "restructureDir": "i18n",
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false,
    "typedPages": true,
    "typedOptionsAndMessages": false,
    "generatedLocaleFilePathFormat": "absolute",
    "alternateLinkCanonicalQueries": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false,
    "optimizeTranslationDirective": true
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "premiumId": 1,
      "files": [
        "/app/apps/mini/i18n/locales/en.json"
      ]
    },
    {
      "code": "de",
      "premiumId": 0,
      "files": [
        "/app/apps/mini/i18n/locales/de.json"
      ]
    },
    {
      "code": "pl",
      "premiumId": 14,
      "files": [
        "/app/apps/mini/i18n/locales/pl.json"
      ]
    },
    {
      "code": "cs",
      "premiumId": 5,
      "files": [
        "/app/apps/mini/i18n/locales/cs.json"
      ]
    },
    {
      "code": "et",
      "premiumId": 6,
      "files": [
        "/app/apps/mini/i18n/locales/et.json"
      ]
    },
    {
      "code": "es",
      "premiumId": 7,
      "files": [
        "/app/apps/mini/i18n/locales/es.json"
      ]
    },
    {
      "code": "fr",
      "premiumId": 2,
      "files": [
        "/app/apps/mini/i18n/locales/fr.json"
      ]
    },
    {
      "code": "hr",
      "premiumId": 8,
      "files": [
        "/app/apps/mini/i18n/locales/hr.json"
      ]
    },
    {
      "code": "it",
      "premiumId": 9,
      "files": [
        "/app/apps/mini/i18n/locales/it.json"
      ]
    },
    {
      "code": "lv",
      "premiumId": 10,
      "files": [
        "/app/apps/mini/i18n/locales/lv.json"
      ]
    },
    {
      "code": "lt",
      "premiumId": 11,
      "files": [
        "/app/apps/mini/i18n/locales/lt.json"
      ]
    },
    {
      "code": "hu",
      "premiumId": 12,
      "files": [
        "/app/apps/mini/i18n/locales/hu.json"
      ]
    },
    {
      "code": "nl",
      "premiumId": 13,
      "files": [
        "/app/apps/mini/i18n/locales/nl.json"
      ]
    },
    {
      "code": "pt",
      "premiumId": 4,
      "files": [
        "/app/apps/mini/i18n/locales/pt.json"
      ]
    },
    {
      "code": "ro",
      "premiumId": 15,
      "files": [
        "/app/apps/mini/i18n/locales/ro.json"
      ]
    },
    {
      "code": "sk",
      "premiumId": 16,
      "files": [
        "/app/apps/mini/i18n/locales/sk.json"
      ]
    },
    {
      "code": "sl",
      "premiumId": 17,
      "files": [
        "/app/apps/mini/i18n/locales/sl.json"
      ]
    },
    {
      "code": "sr",
      "premiumId": 23,
      "files": [
        "/app/apps/mini/i18n/locales/sr.json"
      ]
    },
    {
      "code": "tr",
      "premiumId": 18,
      "files": [
        "/app/apps/mini/i18n/locales/tr.json"
      ]
    },
    {
      "code": "el",
      "premiumId": 3,
      "files": [
        "/app/apps/mini/i18n/locales/el.json"
      ]
    },
    {
      "code": "bg",
      "premiumId": 19,
      "files": [
        "/app/apps/mini/i18n/locales/bg.json"
      ]
    },
    {
      "code": "ru",
      "premiumId": 20,
      "files": [
        "/app/apps/mini/i18n/locales/ru.json"
      ]
    }
  ],
  "defaultLocale": "de",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": true,
  "langDir": "locales",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": ".autobid.de",
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "customRoutes": "config",
  "pages": {
    "auction/[slug]": {
      "bg": "/turg/[slug]",
      "cs": "/aukce/[slug]",
      "de": "/auktion/[slug]",
      "el": "/dhmoprasia/[slug]",
      "en": "/auction/[slug]",
      "es": "/subasta/[slug]",
      "et": "/oksjon/[slug]",
      "fr": "/encheres/[slug]",
      "hr": "/aukcija/[slug]",
      "hu": "/arveres/[slug]",
      "it": "/asta/[slug]",
      "lt": "/aukcione/[slug]",
      "lv": "/izsole/[slug]",
      "nl": "/veiling/[slug]",
      "pl": "/aukcja/[slug]",
      "pt": "/leilao/[slug]",
      "ro": "/licitatie/[slug]",
      "ru": "/aukcion/[slug]",
      "sk": "/aukcie/[slug]",
      "sl": "/drazba/[slug]",
      "sr": "/aukcija/[slug]",
      "tr": "/acik-arttirma/[slug]"
    },
    "auction/current/[slug]": {
      "bg": "/turg/tekush/[slug]",
      "cs": "/aukce/aktualni/[slug]",
      "de": "/auktion/aktuell/[slug]",
      "el": "/dhmoprasia/reyma/[slug]",
      "en": "/auction/current/[slug]",
      "es": "/subasta/actual/[slug]",
      "et": "/oksjon/praegune/[slug]",
      "fr": "/encheres/actuel/[slug]",
      "hr": "/aukcija/trenutno/[slug]",
      "hu": "/arveres/jelenlegi/[slug]",
      "it": "/asta/attuale/[slug]",
      "lt": "/aukcione/srove/[slug]",
      "lv": "/izsole/strava/[slug]",
      "nl": "/veiling/huidig/[slug]",
      "pl": "/aukcja/aktualna/[slug]",
      "pt": "/leilao/atual/[slug]",
      "ro": "/licitatie/actual/[slug]",
      "ru": "/aukcion/tekushij/[slug]",
      "sk": "/aukcie/prud/[slug]",
      "sl": "/drazba/trenutno/[slug]",
      "sr": "/aukcija/trenutni/[slug]",
      "tr": "/acik-arttirma/akim/[slug]"
    },
    "item/[slug]/index": {
      "bg": "/vesh/[slug]",
      "cs": "/polozka/[slug]",
      "de": "/artikel/[slug]",
      "el": "/eidos/[slug]",
      "en": "/item/[slug]",
      "es": "/articulo/[slug]",
      "et": "/uksus/[slug]",
      "fr": "/article/[slug]",
      "hr": "/artikal/[slug]",
      "hu": "/tetel/[slug]",
      "it": "/articolo/[slug]",
      "lt": "/daiktas/[slug]",
      "lv": "/lieta/[slug]",
      "nl": "/item/[slug]",
      "pl": "/przedmiot/[slug]",
      "pt": "/item/[slug]",
      "ro": "/articol/[slug]",
      "ru": "/element/[slug]",
      "sk": "/polozka/[slug]",
      "sl": "/postavka/[slug]",
      "sr": "/predmet/[slug]",
      "tr": "/oge/[slug]"
    },
    "item/[slug]/details": {
      "bg": "/vesh/[slug]/podrobnosti",
      "cs": "/polozka/[slug]/podrobnosti",
      "de": "/artikel/[slug]/einzelheiten",
      "el": "/eidos/[slug]/leptomeries",
      "en": "/item/[slug]/details",
      "es": "/articulo/[slug]/detalles",
      "et": "/uksus/[slug]/uksikasjad",
      "fr": "/article/[slug]/details",
      "hr": "/artikal/[slug]/pojedinosti",
      "hu": "/tetel/[slug]/reszletek",
      "it": "/articolo/[slug]/dettagli",
      "lt": "/daiktas/[slug]/detales",
      "lv": "/lieta/[slug]/detalas",
      "nl": "/item/[slug]/details",
      "pl": "/przedmiot/[slug]/detale",
      "pt": "/item/[slug]/detalhes",
      "ro": "/articol/[slug]/detalii",
      "ru": "/element/[slug]/podrobnosti",
      "sk": "/polozka/[slug]/podrobnosti",
      "sl": "/postavka/[slug]/podrobnosti",
      "sr": "/predmet/[slug]/detaljima",
      "tr": "/oge/[slug]/detaylar"
    }
  },
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "premiumId": 1,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/en.json"
      }
    ]
  },
  {
    "code": "de",
    "premiumId": 0,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/de.json"
      }
    ]
  },
  {
    "code": "pl",
    "premiumId": 14,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/pl.json"
      }
    ]
  },
  {
    "code": "cs",
    "premiumId": 5,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/cs.json"
      }
    ]
  },
  {
    "code": "et",
    "premiumId": 6,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/et.json"
      }
    ]
  },
  {
    "code": "es",
    "premiumId": 7,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/es.json"
      }
    ]
  },
  {
    "code": "fr",
    "premiumId": 2,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/fr.json"
      }
    ]
  },
  {
    "code": "hr",
    "premiumId": 8,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/hr.json"
      }
    ]
  },
  {
    "code": "it",
    "premiumId": 9,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/it.json"
      }
    ]
  },
  {
    "code": "lv",
    "premiumId": 10,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/lv.json"
      }
    ]
  },
  {
    "code": "lt",
    "premiumId": 11,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/lt.json"
      }
    ]
  },
  {
    "code": "hu",
    "premiumId": 12,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/hu.json"
      }
    ]
  },
  {
    "code": "nl",
    "premiumId": 13,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/nl.json"
      }
    ]
  },
  {
    "code": "pt",
    "premiumId": 4,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/pt.json"
      }
    ]
  },
  {
    "code": "ro",
    "premiumId": 15,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/ro.json"
      }
    ]
  },
  {
    "code": "sk",
    "premiumId": 16,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/sk.json"
      }
    ]
  },
  {
    "code": "sl",
    "premiumId": 17,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/sl.json"
      }
    ]
  },
  {
    "code": "sr",
    "premiumId": 23,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/sr.json"
      }
    ]
  },
  {
    "code": "tr",
    "premiumId": 18,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/tr.json"
      }
    ]
  },
  {
    "code": "el",
    "premiumId": 3,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/el.json"
      }
    ]
  },
  {
    "code": "bg",
    "premiumId": 19,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/bg.json"
      }
    ]
  },
  {
    "code": "ru",
    "premiumId": 20,
    "files": [
      {
        "path": "/app/apps/mini/i18n/locales/ru.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
